module.exports = __webpack_public_path__ + "static/media/bg-08.07776b05.jpg";